import React, {Component} from 'react';
import "../../LinkPages/FaqPages/AboutPayment.css"
import {Link} from "react-router-dom";
import FocusPageId from '../../FocusPageId'
import '../Beginners.css';

class MemberRegistrationTopics extends React.Component {
    constructor(props) {
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage = (elementId) => {
        FocusPageId.selectedId = {elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)

    }


    render() {

        return (

            <div className="static-pages">
                <div className="background-div">

                        <h3 className="inline-block-element"><b>会員登録・登録情報について</b></h3>
                        <div className="brElement"></div>
                        <div onClick={() => this.focusPage("a")}>
                            <Link to='/memberregistration'>
                                <h4><b  className="reduce-font-size cart-row-text-color"> 会員登録は無料ですか？</b>
                                </h4>
                            </Link>

                        </div>


                        <div className="brElement"></div>

                        <div onClick={() => this.focusPage("b")}>
                            <Link to='/memberregistration'>
                                <h4><b className="reduce-font-size cart-row-text-color"> 会員登録後、ログインができません。</b>
                                </h4>
                            </Link>

                        </div>


                        <div className="brElement"></div>
                        <div onClick={() => this.focusPage("c")}>
                            <Link to='/memberregistration'>
                                <h4><b className="reduce-font-size cart-row-text-color"> パスワードを忘れてしまった場合はどうしたらいいですか？</b>
                                </h4>
                            </Link>

                        </div>


                        <div className="brElement"></div>
                        <div onClick={() => this.focusPage("d")}>
                            <Link to='/memberregistration'>
                                <h4><b className="reduce-font-size cart-row-text-color">アカウントの削除方法について教えてください。</b>
                                </h4>
                            </Link>

                        </div>


                        <div className="brElement"></div>
                        <div onClick={() => this.focusPage("e")}>
                            <Link to='/memberregistration'>
                                <h4><b className="reduce-font-size cart-row-text-color"> 住所やメールアドレスの変更手続きはどうすればいいですか？</b>
                                </h4>
                            </Link>

                        </div>


                        <div className="brElement"></div>
                        <div onClick={() => this.focusPage("f")}>
                            <Link to='/memberregistration'>
                                <h4><b className="reduce-font-size cart-row-text-color">パスワードを変更したい場合。</b>
                                </h4>
                            </Link>

                        </div>


                        <div className="brElement"></div>
                        <div onClick={() => this.focusPage("g")}>
                            <Link to='/memberregistration'>
                                <h4><b className="reduce-font-size cart-row-text-color">フリーメールで、会員登録できますか？</b>
                                </h4>
                            </Link>

                        </div>
                        {/*<div className='col-md-10'></div>*/}
                        <div className='faq-link-float-right  col-12-custom'>
                            <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                            </Link>
                        </div>


                </div>
            </div>

        );
    }
}

export default MemberRegistrationTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/MemberRegistrationTopics.js